import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Tab, Tabs, TabsHeader, Typography } from "@material-tailwind/react";

import { Navbar } from "../../Common/Components/Navbar";
import { userAccountController } from "../../Common/Controllers/UserAccountController";
import { alertController } from "../../Common/Controllers/AlertController";
import { accountPageController } from "./Controllers/AccountPageController";
import LoadingOverlay from "../../Common/Components/LoadingOverlay";

export const AccountPage = observer(() => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!userAccountController.isUserAccountDataLoading) {
      if (!userAccountController.currentUser) {
        alertController.displayAlert(
          "Login required",
          "You have to be logged in in order to view this page.",
          "warning",
          4000
        );
        navigate("/latest");
      } else {
        // Fix for Material Tailwind tabs
        (
          document.querySelector(
            `ul[role="tablist"] li[href="${accountPageController.currentTab}"]`
          ) as HTMLLIElement
        )?.click();
      }
    }
  }, [accountPageController.currentTab, userAccountController.isUserAccountDataLoading]);

  const onTabChange = (tab: "profile" | "settings" | "addresses" | "orders") => {
    navigate(`/account/${tab}`)
  }

  return (
    <div className={"flex flex-col w-full mt-[65px] mdh:mt-[113px] lgh:mt-[129px]"}>
      <Navbar isBasketIconEnabled={true} isAccountIconEnabled={false} isSearchable={false} isInline={false} />
      <div className="flex flex-col w-full gap-2 md:gap-4 md:max-w-[780px] lg:max-w-[900px] xl:max-w-[1100px] 2xl:max-w-[1200px] mx-auto h-[calc(100vh-81.6px)] md:h-[calc(100vh-113.6px)] lg:h-[calc(100vh-129.6px)]">
        <div className="w-full">
          <Typography variant="h1" color="white" className="mb-2 mdh:mt-2 text-center">Account</Typography>
          <Tabs
            value={accountPageController.currentTab}
            className={"mb-2 w-full border md:rounded-md"}
          >
            <TabsHeader className="bg-main/75">
              <Tab value="profile" onClick={_ => onTabChange("profile")} className="text-white" activeClassName="!text-main">Profile</Tab>
              <Tab value="settings" onClick={_ => onTabChange("settings")} className="text-white" activeClassName="!text-main">Settings</Tab>
              <Tab value="addresses" onClick={_ => onTabChange("addresses")} className="text-white" activeClassName="!text-main">Addresses</Tab>
              <Tab value="orders" onClick={_ => onTabChange("orders")} className="text-white" activeClassName="!text-main">Orders</Tab>
            </TabsHeader>
          </Tabs>
        </div>
        <div className="flex flex-col items-center h-full overflow-y-auto">
          <Outlet />
          <LoadingOverlay isVisible={userAccountController.isUserAccountDataLoading} />
        </div>
      </div>
    </div>
  )
})

